import useEventListener, { HandlerFn } from "./useEventListener";

export type { HandlerFn };
export default function useWindowEventListener(
  eventName: string,
  handler: HandlerFn
) {
  return useEventListener(eventName, handler, window);
}
